import { ISelectOption } from '../../ui-toolkit';
import { IContactFunctionData } from './IContactFunctionData';
import { labelComparator } from '../../utilities/labelComparator';

export const activeClientContactsFunctionsOptions = (contactFunctions: IContactFunctionData[]): ISelectOption[] =>
  contactFunctions
    .filter((value) => value.isClient && value.isActive)
    .map((fun) => ({
      label: fun.label,
      value: fun.id,
    }))
    .toSorted(labelComparator);
